var _style, _defs, _path, _path2, _defs2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 980 700",
    style: {
      enableBackground: "new 0 0 980 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000080907818868520071300000010679549552112111797_);}\n\t.st1{fill:#012169;}\n\t.st2{stroke:#FFFFFF;stroke-width:117.1324;}\n\t.st3{clip-path:url(#SVGID_00000074437311299735688740000012272210222943840129_);stroke:#C8102E;stroke-width:78.0883;}\n\t.st4{stroke:#FFFFFF;stroke-width:195.2207;}\n\t.st5{stroke:#C8102E;stroke-width:117.1324;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 980,
    height: 700
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078003297697154534680000010014080580101242814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078003297697154534680000010014080580101242814_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0v700h980V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0l980,700 M980,0L0,700"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000079473273005019842370000011616222973193959344_",
    points: "490,350 980,350 980,700 490,700 0,700 0,350  0,0 490,0 980,0  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003783393888494888370000002605751737723267730_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079473273005019842370000011616222973193959344_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000003783393888494888370000002605751737723267730_)",
      stroke: "#C8102E",
      strokeWidth: 78.0883
    },
    d: " M0,0l980,700 M980,0L0,700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M490,0v700 M0,350h980"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M490,0v700 M0,350h980"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.3e0e6c54b1ae14aebe7abca0f3d8fffc.svg";
export { ForwardRef as ReactComponent };